<template>
  <main :class="$style.main">
    <!--show/hide browser warning-->
    <div 
      v-if="browserType"
      :class="$style.noticeBanner">
      <span>{{ $t('browsernotice.message') }}
    </span></div>
    <cbr-header v-if="$route.meta.header">
      <cbr-logo 
        slot="logo" 
        :src="config.logo || ''" 
        position="left" />
    </cbr-header>

    <cbr-hero
      v-if="$route.meta.hero && state === 'STATE_INITIALIZED'"
      :image="config.hero"      
    />

    <section :class="$style.mainSection">
      <router-view v-if="state === 'STATE_INITIALIZED'" />

      <obj-spinner v-else-if="state === 'STATE_LOADING'" />

      <span 
        v-else 
        :class="$style.notFound">{{ $t('page_not_found') }}</span>
    </section>

    <cbr-footer />
  </main>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import CbrHeader from '../components/CbrHeader.vue'
import CbrLogo from '../components/CbrLogo.vue'
import CbrHero from '../components/CbrHero.vue'
import CbrFooter from '../components/CbrFooter.vue'
import ObjSpinner from '../components/ObjSpinner.vue'

const STATE_LOADING = 'STATE_LOADING'
const STATE_INITIALIZED = 'STATE_INITIALIZED'
const STATE_NOT_FOUND = 'STATE_NOT_FOUND'

//type of browser checking logic
var isIe
if (/*@cc_on!@*/ false || !!document.documentMode) {
  isIe = true
} else isIe = false

export default {
  components: {
    CbrHeader,
    CbrHero,
    CbrLogo,
    CbrFooter,
    ObjSpinner
  },

  props: {
    portalUuid: {
      type: String | undefined,
      default: undefined
    }
  },

  data() {
    return {
      state: STATE_LOADING,
      browserType: isIe
    }
  },

  computed: {
    ...mapState('config', ['identifier', 'config'])
  },

  created() {
    if (!this.portalUuid) {
      this.state = STATE_NOT_FOUND
      return
    }

    this.setPortalUuid(this.portalUuid)
      .then(() => {
        this.state = STATE_INITIALIZED
      })
      .catch(() => {
        this.state = STATE_NOT_FOUND
      })
  },

  methods: {
    ...mapActions('config', ['setPortalUuid'])
  }
}
</script>

<style module>
.main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.mainSection {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}

.notFound {
  text-align: center;
  max-width: 60vw;
  font-size: 1.5em;
}

.noticeBanner {
  padding: 10px 2px 15px 4px;
  background-color: black;
  text-align: center;
  font-size: 3vmin;
  color: #fff;
  font-family: TheSansGLS;
}
a {
  color: white;
}
</style>


// WEBPACK FOOTER //
// client/views/AbstractAppPage.vue